// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/BrittanySignatureScript.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   PROJECT DETAIL - STYLES CENTRALISÉS ET ORGANISÉS
   Architecture: BEM-inspired, Mobile-First, Performance-Optimized
   ======================================================================== */

/* ========================================================================
   0. POLICES PERSONNALISÉES
   ======================================================================== */

@font-face {
  font-family: 'Brittany';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* ========================================================================
   1. ANIMATIONS GLOBALES
   ======================================================================== */

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Galerie Marinette en pleine largeur */
.marinette-gallery {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.marinette-gallery img {
  width: 100%;
  height: auto;
  display: block;
  max-height: none;
}

/* Galerie en pleine largeur (utilisée pour Marinette) */
.gallery-full-width {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.gallery-full-width .gallery-item {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.gallery-full-width img {
  width: 100%;
  height: auto;
  display: block;
}

/* ========================================================================
   2. HERO SECTION
   ======================================================================== */

/* Hero wrapper avec effet parallax */
.hero-image-wrapper {
  position: relative;
  width: 100%;
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  animation: fadeInUp 0.8s ease-out;
}

.hero-image-wrapper img {
  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.hero-image-wrapper:hover img {
  transform: scale(1.00);
}

/* Hero logo avec animations fluides */
[class~="hero-logo"], 
.hero-logo {
  filter: drop-shadow(0 25px 80px rgba(0, 0, 0, 0.15));
  transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  animation: fadeInScale 0.8s ease-out;
}

.hero-image-wrapper:hover [class~="hero-logo"], 
.hero-image-wrapper:hover .hero-logo {
  filter: drop-shadow(0 35px 100px rgba(0, 0, 0, 0.25));
  transform: translateY(-4px) scale(1.04);
}

/* ========================================================================
   3. IMAGE CONTAINERS & HOVER EFFECTS
   ======================================================================== */

/* Container d'image avec effet hover */
.image-container-hover {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  border-radius: 1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.image-container-hover img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: inherit;
}

.image-container-hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 1;
  pointer-events: none;
  border-radius: inherit;
}

.image-container-hover:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2), 0 8px 24px rgba(0, 0, 0, 0.12);
}

.image-container-hover:hover::before {
  opacity: 1;
}

.image-container-hover:hover img {
  transform: scale(1.00);
  filter: brightness(1.05) saturate(1.15) contrast(1.05);
}

/* Image loading skeleton */
.image-loading {
  background: #f0f0f0;
  background-size: 1000px 100%;
  animation: shimmer 2s infinite linear;
}

/* ========================================================================
   4. MOODBOARD & LOOKBOOK
   ======================================================================== */

/* Moodboard item avec effet shimmer */
.moodboard-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.moodboard-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  transition: left 0.5s ease;
}

.moodboard-item:hover::after {
  left: 100%;
}

/* Lookbook avec effet de cadre élégant */
.lookbook-item {
  position: relative;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.lookbook-item::before {
  content: '';
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  opacity: 0;
  transition: all 0.4s ease;
  z-index: 2;
  pointer-events: none;
}

.lookbook-item:hover::before {
  opacity: 1;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
}

/* ========================================================================
   5. GALLERY - GRILLES ET EFFETS
   ======================================================================== */

/* Médias responsives (images/vidéos/iframes) */
.responsive-media {
  position: relative;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

.responsive-media__content {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  background-color: #000;
}

.responsive-media--rounded-sm { border-radius: 8px; }
.responsive-media--rounded-lg { border-radius: 16px; }

/* Ajustement des médias quand utilisés hors conteneur */
video,
iframe {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Gallery item avec animation staggered */
.gallery-item {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.6s ease-out backwards;
}

.gallery-item:nth-child(1) { animation-delay: 0.05s; }
.gallery-item:nth-child(2) { animation-delay: 0.1s; }
.gallery-item:nth-child(3) { animation-delay: 0.15s; }
.gallery-item:nth-child(4) { animation-delay: 0.2s; }
.gallery-item:nth-child(5) { animation-delay: 0.25s; }
.gallery-item:nth-child(6) { animation-delay: 0.3s; }

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

/* Gallery grid - disposition optimisée */
.gallery-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 1rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Positionnement spécifique pour optimiser l'espace */
.gallery-item:nth-child(1) { grid-column: 1; grid-row: 1; }
.gallery-item:nth-child(2) { grid-column: 2; grid-row: 1; }
.gallery-item:nth-child(3) { grid-column: 3; grid-row: 1; }
.gallery-item:nth-child(4) { grid-column: 1; grid-row: 2; }
.gallery-item:nth-child(5) { grid-column: 2; grid-row: 2; }
.gallery-item:nth-child(6) { 
  grid-column: 3; 
  grid-row: 1 / span 2;
}

.gallery-item:nth-child(6) img {
  height: 100%;
  object-fit: cover;
}

/* ========================================================================
   6. SECTIONS & UI ELEMENTS
   ======================================================================== */

/* Section avec animation au scroll */
.section-animated {
  animation: fadeInUp 0.8s ease-out backwards;
}

/* Titre avec header du projet */
.project-header h1 {
  color: inherit;
}

/* Titre de section avec soulignement animé */
.section-title-animated {
  position: relative;
  display: inline-block;
}

.section-title-animated::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 0;
  height: 3px;
  background: currentColor;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.section-title-animated.in-view::after {
  width: 60%;
}

/* Bouton élégant avec effet glissement */
.btn-elegant {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn-elegant::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transition: left 0.5s ease;
  z-index: -1;
}

.btn-elegant:hover::before {
  left: 100%;
}

.btn-elegant:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.btn-elegant:active {
  transform: translateY(0);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* Effet glassmorphism pour overlays */
.glass-effect {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(25px) saturate(190%);
  -webkit-backdrop-filter: blur(25px) saturate(190%);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both;
}

/* ========================================================================
   7. LAYOUTS - SECTIONS AVEC VISUELS
   ======================================================================== */

/* Layout principal: texte + visuels alternés */
.section-visuals-layout {
  display: grid;
  grid-template-columns: 1fr minmax(0, clamp(420px, 36vw, 760px));
  gap: 3rem;
  align-items: start;
  max-width: 100%;
}

.section-visuals-layout .text-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section-visuals-layout .visual-column {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: flex-start;
}

.section-visuals-layout .visual-column .image-container-hover {
  box-shadow: 0 12px 40px rgba(0,0,0,0.12);
}

.section-visuals-layout .visual-column img {
  width: 100%;
  height: auto;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.5s ease;
}

.section-visuals-layout .visual-column img:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
}

/* Variations de taille par section */
.section-visuals-layout:first-of-type .visual-column .image-container-hover {
  max-width: 100%;
}

.section-visuals-layout:nth-of-type(2) {
  align-items: stretch;
}

.section-visuals-layout:nth-of-type(2) .visual-column .image-container-hover {
  max-width: 100%;
  height: 100%;
}

.section-visuals-layout:nth-of-type(2) .visual-column img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Hover adapté pour petites images */
.section-visuals-layout:first-of-type .image-container-hover:hover,
.section-visuals-layout:nth-of-type(2) .image-container-hover:hover {
  transform: translateY(-3px) scale(1.005);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.08);
}

.section-visuals-layout:first-of-type .image-container-hover:hover img,
.section-visuals-layout:nth-of-type(2) .image-container-hover:hover img {
  transform: scale(1.002);
  filter: brightness(1.02) saturate(1.05) contrast(1.02);
}

/* Alternance gauche/droite */
.section-visuals-layout.visuals-left {
  grid-template-columns: minmax(0, clamp(420px, 36vw, 760px)) 1fr;
}

.section-visuals-layout.visuals-right {
  grid-template-columns: 1fr minmax(0, clamp(420px, 36vw, 760px));
}

/* Override 1ère section: flex layout avec image à gauche */
.section-visuals-layout.is-first {
  display: flex !important;
  gap: 1rem !important;
  align-items: stretch !important;
}

.section-visuals-layout.is-first .visual-column {
  order: 0 !important;
  /* further reduced to make image column even smaller */
  flex: 0 0 14rem !important;
  display: flex !important;
  align-items: stretch !important;
}

.section-visuals-layout.is-first .text-column {
  order: 1 !important;
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
}

.section-visuals-layout.is-first .visual-column .image-container-hover {
  flex: 1 1 auto !important;
  height: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0.75rem !important;
  box-shadow: 0 12px 40px rgba(0,0,0,0.12) !important;
}

.section-visuals-layout.is-first .visual-column img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  display: block !important;
  border-radius: inherit !important;
}


/* ========================================================================
   8. LAYOUTS SPÉCIAUX - CHEMISTRY
   ======================================================================== */

/* Chemistry: collapse gaps pour éviter les bandes vides */
.section-visuals-layout.chemistry .visual-column {
  gap: 0;
  box-shadow: 0 12px 40px rgba(0,0,0,0.08);
  border-radius: 12px;
  background-color: #fff;
  overflow: hidden;
}

.section-visuals-layout.chemistry .visual-column .image-container-hover {
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-radius: 0;
  box-shadow: none;
}

.section-visuals-layout.chemistry .visual-column .image-container-hover img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.section-visuals-layout.chemistry .visual-column .image-container-hover:first-child img {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.section-visuals-layout.chemistry .visual-column .image-container-hover:last-child img {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

/* Chemistry: layout 3 colonnes pour section personnages */
.characters-layout {
  display: grid;
  grid-template-columns: minmax(0, 280px) 1fr minmax(0, 280px);
  gap: 2rem;
  align-items: start;
}

.characters-layout__left,
.characters-layout__right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.characters-layout__left img,
.characters-layout__right img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* ========================================================================
   9. PROJET MOUSTIK - LAYOUTS ET GALERIE
   ======================================================================== */

.moustik-layout {
  position: relative;
}

.moustik-layout .image-container-hover {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.moustik-layout .image-container-hover:hover {
  transform: translateY(-10px) scale(1.03);
  box-shadow: 0 20px 60px rgba(245, 255, 0, 0.25), 0 8px 24px rgba(245, 255, 0, 0.15);
}

/* Galerie Moustik avec masonry */
.gallery-grid-moustik {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

.gallery-grid-moustik .gallery-item {
  width: 100%;
}

.gallery-grid-moustik .gallery-item img {
  width: 100%;
  height: auto;
  display: block;
}

/* ========================================================================
   10. PROJET BORROWED TIME - LAYOUTS ET GALERIE
   ======================================================================== */

/* Typographie spécifique */
.project-detail--borrowed-time h1,
.project-detail--borrowed-time h2,
.project-detail--borrowed-time h3 {
  font-family: "Brittany", "Great Vibes", "Caveat", cursive;
}

/* Layout 2 colonnes */
.borrowed-time-layout {
  position: relative;
}

.borrowed-time-layout .image-container-hover {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.borrowed-time-layout .image-container-hover:hover {
  transform: translateY(-10px) scale(1.03);
  box-shadow: 0 20px 60px rgba(199, 75, 124, 0.25), 0 8px 24px rgba(199, 75, 124, 0.15);
}

/* Sections à 2 colonnes */
.project-detail.borrowed-time .section-two-col {
  display: grid;
  grid-template-columns: 1fr minmax(240px, 420px);
  gap: 1rem;
  align-items: start;
}

.project-detail.borrowed-time .section-two-col .section-text {
  margin-bottom: 0.5rem;
}

.project-detail.borrowed-time .section-two-col .section-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

/* Images après sections (moodboard/dessins) */
.project-detail.borrowed-time .after-image {
  display: block;
  width: 100%;
  max-width: 880px;
  margin: 0.75rem auto 1.25rem;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
}

/* Galerie masonry */
.project-detail.borrowed-time .gallery-masonry {
  column-count: 1;
  column-gap: 0.75rem;
}

.project-detail.borrowed-time .gallery-masonry .gallery-item {
  page-break-inside: avoid;
  break-inside: avoid;
  margin: 0 0 0.75rem;
}

.project-detail.borrowed-time .gallery-masonry .gallery-item img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}

/* Galerie grid avec tailles variées */
.project-detail--borrowed-time .gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(1) {
  grid-column: span 2;
  grid-row: span 2;
}

.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(5) {
  grid-column: span 2;
}

.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(9),
.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(10) {
  grid-row: span 2;
}

/* ========================================================================
   11. PROJET MARINETTE - AJUSTEMENTS SPÉCIFIQUES
   ======================================================================== */

.project-detail--marinette .section-visuals-layout:nth-of-type(2) {
  align-items: flex-start !important;
}

.project-detail--marinette .section-visuals-layout:nth-of-type(2) .text-column,
.project-detail--marinette .section-visuals-layout:nth-of-type(2) .visual-column {
  align-self: flex-start !important;
}

.project-detail--marinette .section-visuals-layout:nth-of-type(2) .visual-column .image-container-hover {
  margin-top: 0 !important;
}

.project-detail--marinette .section-visuals-layout:nth-of-type(2) .visual-column img {
  display: block;
}

.project-detail--marinette .section-visuals-layout.marinette-second {
  align-items: flex-start !important;
}

.project-detail--marinette .section-visuals-layout.marinette-second .text-column,
.project-detail--marinette .section-visuals-layout.marinette-second .visual-column {
  align-self: flex-start !important;
}

.project-detail--marinette .section-visuals-layout.marinette-second .visual-column .image-container-hover {
  margin-top: 0 !important;
}

.project-detail--marinette .section-visuals-layout.marinette-second .visual-column img {
  display: block;
}

/* Borrowed Time: section storytelling avec image plus grande */
.project-detail.borrowed-time .section-two-col.section-story {
  grid-template-columns: 1fr clamp(420px, 36vw, 760px);
  gap: 1.25rem;
}

.project-detail.borrowed-time .section-two-col.section-story .section-media img {
  width: 100%;
  height: auto;
  max-height: 85vh;
  object-fit: contain;
}

/* ========================================================================
   12. ACCESSIBILITÉ ET PERFORMANCE
   ======================================================================== */

/* Focus visible pour accessibilité */
*:focus-visible {
  outline: 2px solid rgba(233, 30, 140, 0.5);
  outline-offset: 4px;
  border-radius: 4px;
}

/* Optimisation GPU pour éléments animés */
.image-container-hover,
.gallery-item,
.lookbook-item,
.moodboard-item,
.btn-elegant {
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* ========================================================================
   13. RESPONSIVE - MEDIA QUERIES CONSOLIDÉES
   ======================================================================== */

/* Desktop large (1280px+) */
@media (min-width: 1280px) {
  .project-detail.borrowed-time .section-two-col.section-story {
    grid-template-columns: 1fr clamp(520px, 42vw, 900px);
  }
}

/* Desktop (1024px - 1279px) */
@media (max-width: 1024px) {
  .hero-image-wrapper {
    min-height: 70vh;
  }

  .section-visuals-layout {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .section-visuals-layout .visual-column {
    order: 2;
  }

  .section-visuals-layout .visual-column img {
    max-height: 28.125rem;
  }

  .section-visuals-layout.is-first {
    display: grid !important;
    gap: 2rem !important;
  }

  .section-visuals-layout.is-first .visual-column,
  .section-visuals-layout.is-first .text-column {
    order: initial !important;
    flex: initial !important;
  }

  .section-visuals-layout.is-first .visual-column img {
    height: auto !important;
  }

  .characters-layout {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .characters-layout__left,
  .characters-layout__right {
    justify-content: center;
  }

  .gallery-grid-moustik {
    flex-direction: column;
    gap: 1rem;
  }

  .gallery-grid-moustik .gallery-item {
    width: 100%;
  }

  .project-detail--borrowed-time .gallery-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(1) {
    grid-column: span 1;
    grid-row: span 1;
  }

  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(5) {
    grid-column: span 1;
  }

  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(9),
  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(10) {
    grid-row: span 1;
  }

  .project-detail.borrowed-time .gallery-masonry {
    column-count: 3;
  }
}

/* Tablet (768px - 1023px) */
@media (max-width: 968px) {
  .borrowed-time-layout {
    grid-template-columns: 1fr !important;
    gap: 2rem !important;
  }

  .borrowed-time-layout .image-column {
    position: static !important;
    order: -1;
  }
}

/* Mobile large et Tablet (768px - 967px) */
@media (max-width: 768px) {
  .hero-image-wrapper {
    min-height: 60vh;
  }

  .hero-image-wrapper:hover [class~="hero-logo"],
  .hero-image-wrapper:hover .hero-logo {
    transform: translateY(-2px) scale(1.02);
  }

  .image-container-hover:hover {
    transform: translateY(-4px) scale(1.01);
  }

  .gallery-item:hover {
    transform: translateY(-3px);
  }

  .btn-elegant:hover {
    transform: translateY(-1px);
  }

  .section-visuals-layout {
    gap: 1.5rem;
  }

  .section-visuals-layout .visual-column img {
    max-height: 21.875rem;
  }

  /* Réduire légèrement les rayons sur mobile pour économiser l'espace visible */
  .responsive-media { border-radius: 10px; }

  .gallery-grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
  }

  .gallery-item:nth-child(1) { grid-column: 1; grid-row: 1; }
  .gallery-item:nth-child(2) { grid-column: 2; grid-row: 1; }
  .gallery-item:nth-child(3) { grid-column: 1; grid-row: 2; }
  .gallery-item:nth-child(4) { grid-column: 2; grid-row: 2; }
  .gallery-item:nth-child(5) { grid-column: 1; grid-row: 3; }
  .gallery-item:nth-child(6) { grid-column: 2; grid-row: 3; }

  .gallery-item:nth-child(6) img {
    height: auto;
  }

  .moustik-layout {
    grid-template-columns: 1fr !important;
    gap: 2rem !important;
  }

  .moustik-layout > div {
    position: static !important;
  }

  .project-detail.borrowed-time .section-two-col {
    grid-template-columns: 1fr;
  }
}

/* Mobile (640px - 767px) */
@media (max-width: 640px) {
  .gallery-grid-moustik {
    flex-direction: column;
    gap: 1rem;
  }

  /* Toutes galeries en 1 colonne pour lisibilité sur petits écrans */
  .gallery-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .project-detail--borrowed-time .gallery-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .project-detail.borrowed-time .gallery-masonry {
    column-count: 2;
  }
}

/* Mobile petit et très petit */
@media (max-width: 480px) {
  .project-detail.borrowed-time .gallery-masonry {
    column-count: 1;
  }
}

/* Tablet (1024px - 1199px) spécifique Moustik */
@media (max-width: 1200px) {
  .moustik-layout {
    grid-template-columns: 1fr 3fr 1fr !important;
    gap: 1.5rem !important;
  }
}

/* Préférence réduite pour les animations (accessibilité) */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* ========================================================================
   PROJET : LES FEMMES DU LAVOIR (LES LAVANDIÈRES)
   ======================================================================== */

.project-detail--les-femmes-du-lavoir,
.project-detail--les-lavandieres {
  background-color: #F8F5F2;
  color: #1A1A1A;
  min-height: 100vh;
  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;
  overflow-x: hidden;
}

/* Nav header */
.lavoir-nav-header {
  padding: 1.5rem 2.5rem;
  position: sticky;
  top: 0;
  background-color: rgba(248, 245, 242, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.lavoir-back-button {
  background: transparent;
  border: 1.5px solid #1A1A1A;
  color: #1A1A1A;
  padding: 0.5rem 1.4rem;
  border-radius: 30px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.05em;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.lavoir-back-button:hover {
  background: #1A1A1A;
  color: #F8F5F2;
  transform: translateX(-3px);
}

/* Main Container */
.lavoir-main {
  max-width: 1300px;
  margin: 0 auto;
  padding: 2rem 5% 6rem;
}

/* Hero Section */
.lavoir-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5rem;
  animation: fadeInUp 0.8s ease-out;
}

.lavoir-poster-container {
  max-width: 900px;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.1);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.lavoir-poster-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 55px rgba(0, 0, 0, 0.14);
}

.lavoir-poster-img {
  width: 100%;
  height: auto;
  display: block;
}

.lavoir-tagline {
  margin-top: 2.2rem;
  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;
  font-size: clamp(1.05rem, 2.2vw, 1.25rem);
  color: #2A2A2A;
  text-align: center;
  max-width: 820px;
  line-height: 1.7;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0.02em;
}

/* Header section */
.lavoir-header-section {
  text-align: center;
  margin: 5rem 0 7rem;
}

.lavoir-main-title {
  font-family: 'Brittany', 'Great Vibes', 'Caveat', cursive;
  font-size: clamp(3.2rem, 8vw, 6rem);
  font-weight: normal;
  color: #1A1A1A;
  margin: 0 0 1rem 0;
  line-height: 1.15;
  letter-spacing: 0.02em;
}

.lavoir-main-subtitle {
  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;
  font-size: clamp(0.95rem, 2vw, 1.2rem);
  color: #4A4A4A;
  letter-spacing: 0.1em;
  margin: 0;
  font-weight: 500;
}

/* Common Section */
.lavoir-section {
  margin-bottom: 7rem;
}

.lavoir-section-heading {
  font-family: 'Brittany', 'Great Vibes', 'Caveat', cursive;
  font-size: clamp(2.8rem, 6.5vw, 4.8rem);
  font-weight: normal;
  color: #1A1A1A;
  text-align: center;
  margin: 0 0 3.5rem 0;
  line-height: 1.2;
}

/* Section L'histoire */
.lavoir-histoire-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.lavoir-histoire-text p {
  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;
  font-size: 1.05rem;
  line-height: 1.95;
  color: #2D2D2D;
  margin: 0 0 1.8rem 0;
  text-align: justify;
}

.lavoir-histoire-text p:last-child {
  margin-bottom: 0;
}

.lavoir-histoire-media {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.08);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.lavoir-histoire-media:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.12);
}

.lavoir-histoire-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* Section Inspirations */
.lavoir-inspirations-container {
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.08);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.lavoir-inspirations-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.12);
}

.lavoir-inspirations-img {
  width: 100%;
  height: auto;
  display: block;
}

/* Section Silhouettes */
.lavoir-silhouettes-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem 2rem;
  align-items: end;
  justify-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.lavoir-silhouette-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.lavoir-silhouette-item:hover {
  transform: translateY(-10px) scale(1.02);
}

.lavoir-silhouette-img {
  max-width: 100%;
  max-height: 480px;
  width: auto;
  height: auto;
  display: block;
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.06));
}

/* Section Galerie */
.lavoir-gallery-layout {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1250px;
  margin: 0 auto;
}

.lavoir-gallery-row {
  display: flex;
  gap: 1.8rem;
  align-items: stretch;
  width: 100%;
}

.lavoir-gallery-item {
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  background-color: #EFEBE6;
}

.lavoir-gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.14);
}

.lavoir-gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.lavoir-gallery-item:hover img {
  transform: scale(1.025);
}

/* Row 1 proportions: portrait (750x1000) / landscape (1200x900) / portrait (750x1000) */
.lavoir-gallery-row--3 .lavoir-gallery-item--portrait {
  flex: 0.75 1;
}
.lavoir-gallery-row--3 .lavoir-gallery-item--landscape {
  flex: 1.333 1;
}

/* Row 2 proportions: 1229x920 / 1433x808 */
.lavoir-gallery-row--2 .lavoir-gallery-item--medium {
  flex: 1.336 1;
}
.lavoir-gallery-row--2 .lavoir-gallery-item--wide {
  flex: 1.773 1;
}

/* Row 3 proportions: 750x1000 / 1229x921 */
.lavoir-gallery-row--2-alt .lavoir-gallery-item--portrait {
  flex: 0.75 1;
}
.lavoir-gallery-row--2-alt .lavoir-gallery-item--wide {
  flex: 1.334 1;
}

/* Footer / CTA */
.lavoir-footer {
  text-align: center;
  padding: 6rem 2rem 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.lavoir-footer-title {
  font-family: 'Brittany', 'Great Vibes', 'Caveat', cursive;
  font-size: clamp(3rem, 7vw, 5.2rem);
  font-weight: normal;
  color: #1A1A1A;
  margin: 0 0 2.5rem 0;
  line-height: 1.15;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
}

.lavoir-footer-title:hover {
  color: #61554E;
  transform: scale(1.02);
}

.lavoir-footer-btn {
  background: #1A1A1A;
  color: #F8F5F2;
  border: 1.5px solid #1A1A1A;
  padding: 1.1rem 3rem;
  border-radius: 40px;
  font-size: 1.05rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.lavoir-footer-btn:hover {
  background: transparent;
  color: #1A1A1A;
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.16);
}

/* Responsive */
@media (max-width: 900px) {
  .lavoir-histoire-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .lavoir-silhouettes-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem 1.5rem;
  }

  .lavoir-gallery-row {
    flex-direction: column;
    gap: 1.5rem;
  }

  .lavoir-gallery-item {
    min-height: 300px;
  }
}

/* ========================================================================
   FIN DU FICHIER
   ======================================================================== */`, "",{"version":3,"sources":["webpack://./src/styles/ProjectDetail.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;;6EAE6E;;AAE7E;EACE,uBAAuB;EACvB,+DAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;6EAE6E;;AAE7E;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;6EAE6E;;AAE7E,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;;EAEE,oDAAoD;EACpD,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;;EAEE,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;;6EAE6E;;AAE7E,uCAAuC;AACvC;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,0EAA0E;AAC5E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;;6EAE6E;;AAE7E,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;6EAE6E;;AAE7E,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gCAAgC,kBAAkB,EAAE;AACpD,gCAAgC,mBAAmB,EAAE;;AAErD,wDAAwD;AACxD;;EAEE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,qBAAqB,EAAE;;AAEpD;EACE,2BAA2B;EAC3B,0EAA0E;EAC1E,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sDAAsD;AACtD,6BAA6B,cAAc,EAAE,WAAW,EAAE;AAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;AAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;AAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;AAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;AAC1D;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;6EAE6E;;AAE7E,qCAAqC;AACrC;EACE,2CAA2C;AAC7C;;AAEA,gCAAgC;AAChC;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kDAAkD;EAClD,6CAA6C;EAC7C,kFAAkF;EAClF,qEAAqE;AACvE;;AAEA;;6EAE6E;;AAE7E,+CAA+C;AAC/C;EACE,aAAa;EACb,+DAA+D;EAC/D,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kFAAkF;AACpF;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;;EAEE,wCAAwC;EACxC,0EAA0E;AAC5E;;AAEA;;EAEE,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA,6BAA6B;AAC7B;EACE,+DAA+D;AACjE;;AAEA;EACE,+DAA+D;AACjE;;AAEA,2DAA2D;AAC3D;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,sDAAsD;EACtD,0BAA0B;EAC1B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;AACnC;;;AAGA;;6EAE6E;;AAE7E,0DAA0D;AAC1D;EACE,MAAM;EACN,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E;EACE,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,mFAAmF;AACrF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;6EAE6E;;AAE7E,2BAA2B;AAC3B;;;EAGE,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,qFAAqF;AACvF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;6EAE6E;;AAE7E;EACE,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E,qCAAqC;AACrC;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;;;;;EAKE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;6EAE6E;;AAE7E,4BAA4B;AAC5B;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;;IAEE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,SAAS;EACX;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA,8EAA8E;EAC9E,oBAAoB,mBAAmB,EAAE;;EAEzC;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA,6BAA6B,cAAc,EAAE,WAAW,EAAE;EAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;EAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;EAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;EAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;EAC1D,6BAA6B,cAAc,EAAE,WAAW,EAAE;;EAE1D;IACE,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA,mEAAmE;EACnE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,eAAe;EACjB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,6CAA6C;IAC7C,sBAAsB;EACxB;AACF;;AAEA,2DAA2D;AAC3D;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;;6EAE6E;;AAE7E;;EAEE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;EACjD,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,cAAc;EACd,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mDAAmD;AACrD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wFAAwF;AACxF;EACE,YAAU;AACZ;AACA;EACE,aAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,aAAW;AACb;AACA;EACE,aAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,YAAU;AACZ;AACA;EACE,aAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;EAC1C,8EAA8E;AAChF;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;6EAE6E","sourcesContent":["/* ========================================================================\n   PROJECT DETAIL - STYLES CENTRALISÉS ET ORGANISÉS\n   Architecture: BEM-inspired, Mobile-First, Performance-Optimized\n   ======================================================================== */\n\n/* ========================================================================\n   0. POLICES PERSONNALISÉES\n   ======================================================================== */\n\n@font-face {\n  font-family: 'Brittany';\n  src: url('../assets/fonts/BrittanySignatureScript.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* ========================================================================\n   1. ANIMATIONS GLOBALES\n   ======================================================================== */\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Galerie Marinette en pleine largeur */\n.marinette-gallery {\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n}\n\n.marinette-gallery img {\n  width: 100%;\n  height: auto;\n  display: block;\n  max-height: none;\n}\n\n/* Galerie en pleine largeur (utilisée pour Marinette) */\n.gallery-full-width {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.gallery-full-width .gallery-item {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.gallery-full-width img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ========================================================================\n   2. HERO SECTION\n   ======================================================================== */\n\n/* Hero wrapper avec effet parallax */\n.hero-image-wrapper {\n  position: relative;\n  width: 100%;\n  min-height: 85vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.hero-image-wrapper img {\n  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hero-image-wrapper:hover img {\n  transform: scale(1.00);\n}\n\n/* Hero logo avec animations fluides */\n[class~=\"hero-logo\"], \n.hero-logo {\n  filter: drop-shadow(0 25px 80px rgba(0, 0, 0, 0.15));\n  transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);\n  animation: fadeInScale 0.8s ease-out;\n}\n\n.hero-image-wrapper:hover [class~=\"hero-logo\"], \n.hero-image-wrapper:hover .hero-logo {\n  filter: drop-shadow(0 35px 100px rgba(0, 0, 0, 0.25));\n  transform: translateY(-4px) scale(1.04);\n}\n\n/* ========================================================================\n   3. IMAGE CONTAINERS & HOVER EFFECTS\n   ======================================================================== */\n\n/* Container d'image avec effet hover */\n.image-container-hover {\n  position: relative;\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  border-radius: 1rem;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n}\n\n.image-container-hover img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: inherit;\n}\n\n.image-container-hover::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  z-index: 1;\n  pointer-events: none;\n  border-radius: inherit;\n}\n\n.image-container-hover:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2), 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.image-container-hover:hover::before {\n  opacity: 1;\n}\n\n.image-container-hover:hover img {\n  transform: scale(1.00);\n  filter: brightness(1.05) saturate(1.15) contrast(1.05);\n}\n\n/* Image loading skeleton */\n.image-loading {\n  background: #f0f0f0;\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite linear;\n}\n\n/* ========================================================================\n   4. MOODBOARD & LOOKBOOK\n   ======================================================================== */\n\n/* Moodboard item avec effet shimmer */\n.moodboard-item {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.moodboard-item::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.3);\n  transition: left 0.5s ease;\n}\n\n.moodboard-item:hover::after {\n  left: 100%;\n}\n\n/* Lookbook avec effet de cadre élégant */\n.lookbook-item {\n  position: relative;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.lookbook-item::before {\n  content: '';\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  bottom: 10px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  opacity: 0;\n  transition: all 0.4s ease;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.lookbook-item:hover::before {\n  opacity: 1;\n  top: 15px;\n  left: 15px;\n  right: 15px;\n  bottom: 15px;\n}\n\n/* ========================================================================\n   5. GALLERY - GRILLES ET EFFETS\n   ======================================================================== */\n\n/* Médias responsives (images/vidéos/iframes) */\n.responsive-media {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #000;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.responsive-media__content {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n  background-color: #000;\n}\n\n.responsive-media--rounded-sm { border-radius: 8px; }\n.responsive-media--rounded-lg { border-radius: 16px; }\n\n/* Ajustement des médias quand utilisés hors conteneur */\nvideo,\niframe {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Gallery item avec animation staggered */\n.gallery-item {\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  animation: fadeInUp 0.6s ease-out backwards;\n}\n\n.gallery-item:nth-child(1) { animation-delay: 0.05s; }\n.gallery-item:nth-child(2) { animation-delay: 0.1s; }\n.gallery-item:nth-child(3) { animation-delay: 0.15s; }\n.gallery-item:nth-child(4) { animation-delay: 0.2s; }\n.gallery-item:nth-child(5) { animation-delay: 0.25s; }\n.gallery-item:nth-child(6) { animation-delay: 0.3s; }\n\n.gallery-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n/* Gallery grid - disposition optimisée */\n.gallery-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto auto;\n  gap: 1rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Positionnement spécifique pour optimiser l'espace */\n.gallery-item:nth-child(1) { grid-column: 1; grid-row: 1; }\n.gallery-item:nth-child(2) { grid-column: 2; grid-row: 1; }\n.gallery-item:nth-child(3) { grid-column: 3; grid-row: 1; }\n.gallery-item:nth-child(4) { grid-column: 1; grid-row: 2; }\n.gallery-item:nth-child(5) { grid-column: 2; grid-row: 2; }\n.gallery-item:nth-child(6) { \n  grid-column: 3; \n  grid-row: 1 / span 2;\n}\n\n.gallery-item:nth-child(6) img {\n  height: 100%;\n  object-fit: cover;\n}\n\n/* ========================================================================\n   6. SECTIONS & UI ELEMENTS\n   ======================================================================== */\n\n/* Section avec animation au scroll */\n.section-animated {\n  animation: fadeInUp 0.8s ease-out backwards;\n}\n\n/* Titre avec header du projet */\n.project-header h1 {\n  color: inherit;\n}\n\n/* Titre de section avec soulignement animé */\n.section-title-animated {\n  position: relative;\n  display: inline-block;\n}\n\n.section-title-animated::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 0;\n  width: 0;\n  height: 3px;\n  background: currentColor;\n  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.section-title-animated.in-view::after {\n  width: 60%;\n}\n\n/* Bouton élégant avec effet glissement */\n.btn-elegant {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.btn-elegant::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.2);\n  transition: left 0.5s ease;\n  z-index: -1;\n}\n\n.btn-elegant:hover::before {\n  left: 100%;\n}\n\n.btn-elegant:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n}\n\n.btn-elegant:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n/* Effet glassmorphism pour overlays */\n.glass-effect {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(25px) saturate(190%);\n  -webkit-backdrop-filter: blur(25px) saturate(190%);\n  border: 1.5px solid rgba(255, 255, 255, 0.25);\n  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both;\n}\n\n/* ========================================================================\n   7. LAYOUTS - SECTIONS AVEC VISUELS\n   ======================================================================== */\n\n/* Layout principal: texte + visuels alternés */\n.section-visuals-layout {\n  display: grid;\n  grid-template-columns: 1fr minmax(0, clamp(420px, 36vw, 760px));\n  gap: 3rem;\n  align-items: start;\n  max-width: 100%;\n}\n\n.section-visuals-layout .text-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.section-visuals-layout .visual-column {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.section-visuals-layout .visual-column .image-container-hover {\n  box-shadow: 0 12px 40px rgba(0,0,0,0.12);\n}\n\n.section-visuals-layout .visual-column img {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.5s ease;\n}\n\n.section-visuals-layout .visual-column img:hover {\n  transform: translateY(-4px) scale(1.01);\n  box-shadow: 0 20px 60px rgba(0,0,0,0.18);\n}\n\n/* Variations de taille par section */\n.section-visuals-layout:first-of-type .visual-column .image-container-hover {\n  max-width: 100%;\n}\n\n.section-visuals-layout:nth-of-type(2) {\n  align-items: stretch;\n}\n\n.section-visuals-layout:nth-of-type(2) .visual-column .image-container-hover {\n  max-width: 100%;\n  height: 100%;\n}\n\n.section-visuals-layout:nth-of-type(2) .visual-column img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Hover adapté pour petites images */\n.section-visuals-layout:first-of-type .image-container-hover:hover,\n.section-visuals-layout:nth-of-type(2) .image-container-hover:hover {\n  transform: translateY(-3px) scale(1.005);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.section-visuals-layout:first-of-type .image-container-hover:hover img,\n.section-visuals-layout:nth-of-type(2) .image-container-hover:hover img {\n  transform: scale(1.002);\n  filter: brightness(1.02) saturate(1.05) contrast(1.02);\n}\n\n/* Alternance gauche/droite */\n.section-visuals-layout.visuals-left {\n  grid-template-columns: minmax(0, clamp(420px, 36vw, 760px)) 1fr;\n}\n\n.section-visuals-layout.visuals-right {\n  grid-template-columns: 1fr minmax(0, clamp(420px, 36vw, 760px));\n}\n\n/* Override 1ère section: flex layout avec image à gauche */\n.section-visuals-layout.is-first {\n  display: flex !important;\n  gap: 1rem !important;\n  align-items: stretch !important;\n}\n\n.section-visuals-layout.is-first .visual-column {\n  order: 0 !important;\n  /* further reduced to make image column even smaller */\n  flex: 0 0 14rem !important;\n  display: flex !important;\n  align-items: stretch !important;\n}\n\n.section-visuals-layout.is-first .text-column {\n  order: 1 !important;\n  flex: 1 1 auto !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.section-visuals-layout.is-first .visual-column .image-container-hover {\n  flex: 1 1 auto !important;\n  height: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0.75rem !important;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.12) !important;\n}\n\n.section-visuals-layout.is-first .visual-column img {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  display: block !important;\n  border-radius: inherit !important;\n}\n\n\n/* ========================================================================\n   8. LAYOUTS SPÉCIAUX - CHEMISTRY\n   ======================================================================== */\n\n/* Chemistry: collapse gaps pour éviter les bandes vides */\n.section-visuals-layout.chemistry .visual-column {\n  gap: 0;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.08);\n  border-radius: 12px;\n  background-color: #fff;\n  overflow: hidden;\n}\n\n.section-visuals-layout.chemistry .visual-column .image-container-hover {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.section-visuals-layout.chemistry .visual-column .image-container-hover img {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n.section-visuals-layout.chemistry .visual-column .image-container-hover:first-child img {\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.section-visuals-layout.chemistry .visual-column .image-container-hover:last-child img {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n/* Chemistry: layout 3 colonnes pour section personnages */\n.characters-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 280px) 1fr minmax(0, 280px);\n  gap: 2rem;\n  align-items: start;\n}\n\n.characters-layout__left,\n.characters-layout__right {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.characters-layout__left img,\n.characters-layout__right img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n/* ========================================================================\n   9. PROJET MOUSTIK - LAYOUTS ET GALERIE\n   ======================================================================== */\n\n.moustik-layout {\n  position: relative;\n}\n\n.moustik-layout .image-container-hover {\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.moustik-layout .image-container-hover:hover {\n  transform: translateY(-10px) scale(1.03);\n  box-shadow: 0 20px 60px rgba(245, 255, 0, 0.25), 0 8px 24px rgba(245, 255, 0, 0.15);\n}\n\n/* Galerie Moustik avec masonry */\n.gallery-grid-moustik {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.gallery-grid-moustik .gallery-item {\n  width: 100%;\n}\n\n.gallery-grid-moustik .gallery-item img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ========================================================================\n   10. PROJET BORROWED TIME - LAYOUTS ET GALERIE\n   ======================================================================== */\n\n/* Typographie spécifique */\n.project-detail--borrowed-time h1,\n.project-detail--borrowed-time h2,\n.project-detail--borrowed-time h3 {\n  font-family: \"Brittany\", \"Great Vibes\", \"Caveat\", cursive;\n}\n\n/* Layout 2 colonnes */\n.borrowed-time-layout {\n  position: relative;\n}\n\n.borrowed-time-layout .image-container-hover {\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.borrowed-time-layout .image-container-hover:hover {\n  transform: translateY(-10px) scale(1.03);\n  box-shadow: 0 20px 60px rgba(199, 75, 124, 0.25), 0 8px 24px rgba(199, 75, 124, 0.15);\n}\n\n/* Sections à 2 colonnes */\n.project-detail.borrowed-time .section-two-col {\n  display: grid;\n  grid-template-columns: 1fr minmax(240px, 420px);\n  gap: 1rem;\n  align-items: start;\n}\n\n.project-detail.borrowed-time .section-two-col .section-text {\n  margin-bottom: 0.5rem;\n}\n\n.project-detail.borrowed-time .section-two-col .section-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n/* Images après sections (moodboard/dessins) */\n.project-detail.borrowed-time .after-image {\n  display: block;\n  width: 100%;\n  max-width: 880px;\n  margin: 0.75rem auto 1.25rem;\n  height: auto;\n  object-fit: contain;\n  border-radius: 6px;\n}\n\n/* Galerie masonry */\n.project-detail.borrowed-time .gallery-masonry {\n  column-count: 1;\n  column-gap: 0.75rem;\n}\n\n.project-detail.borrowed-time .gallery-masonry .gallery-item {\n  break-inside: avoid;\n  margin: 0 0 0.75rem;\n}\n\n.project-detail.borrowed-time .gallery-masonry .gallery-item img {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 6px;\n}\n\n/* Galerie grid avec tailles variées */\n.project-detail--borrowed-time .gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(1) {\n  grid-column: span 2;\n  grid-row: span 2;\n}\n\n.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(5) {\n  grid-column: span 2;\n}\n\n.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(9),\n.project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(10) {\n  grid-row: span 2;\n}\n\n/* ========================================================================\n   11. PROJET MARINETTE - AJUSTEMENTS SPÉCIFIQUES\n   ======================================================================== */\n\n.project-detail--marinette .section-visuals-layout:nth-of-type(2) {\n  align-items: flex-start !important;\n}\n\n.project-detail--marinette .section-visuals-layout:nth-of-type(2) .text-column,\n.project-detail--marinette .section-visuals-layout:nth-of-type(2) .visual-column {\n  align-self: flex-start !important;\n}\n\n.project-detail--marinette .section-visuals-layout:nth-of-type(2) .visual-column .image-container-hover {\n  margin-top: 0 !important;\n}\n\n.project-detail--marinette .section-visuals-layout:nth-of-type(2) .visual-column img {\n  display: block;\n}\n\n.project-detail--marinette .section-visuals-layout.marinette-second {\n  align-items: flex-start !important;\n}\n\n.project-detail--marinette .section-visuals-layout.marinette-second .text-column,\n.project-detail--marinette .section-visuals-layout.marinette-second .visual-column {\n  align-self: flex-start !important;\n}\n\n.project-detail--marinette .section-visuals-layout.marinette-second .visual-column .image-container-hover {\n  margin-top: 0 !important;\n}\n\n.project-detail--marinette .section-visuals-layout.marinette-second .visual-column img {\n  display: block;\n}\n\n/* Borrowed Time: section storytelling avec image plus grande */\n.project-detail.borrowed-time .section-two-col.section-story {\n  grid-template-columns: 1fr clamp(420px, 36vw, 760px);\n  gap: 1.25rem;\n}\n\n.project-detail.borrowed-time .section-two-col.section-story .section-media img {\n  width: 100%;\n  height: auto;\n  max-height: 85vh;\n  object-fit: contain;\n}\n\n/* ========================================================================\n   12. ACCESSIBILITÉ ET PERFORMANCE\n   ======================================================================== */\n\n/* Focus visible pour accessibilité */\n*:focus-visible {\n  outline: 2px solid rgba(233, 30, 140, 0.5);\n  outline-offset: 4px;\n  border-radius: 4px;\n}\n\n/* Optimisation GPU pour éléments animés */\n.image-container-hover,\n.gallery-item,\n.lookbook-item,\n.moodboard-item,\n.btn-elegant {\n  will-change: transform;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n/* ========================================================================\n   13. RESPONSIVE - MEDIA QUERIES CONSOLIDÉES\n   ======================================================================== */\n\n/* Desktop large (1280px+) */\n@media (min-width: 1280px) {\n  .project-detail.borrowed-time .section-two-col.section-story {\n    grid-template-columns: 1fr clamp(520px, 42vw, 900px);\n  }\n}\n\n/* Desktop (1024px - 1279px) */\n@media (max-width: 1024px) {\n  .hero-image-wrapper {\n    min-height: 70vh;\n  }\n\n  .section-visuals-layout {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .section-visuals-layout .visual-column {\n    order: 2;\n  }\n\n  .section-visuals-layout .visual-column img {\n    max-height: 28.125rem;\n  }\n\n  .section-visuals-layout.is-first {\n    display: grid !important;\n    gap: 2rem !important;\n  }\n\n  .section-visuals-layout.is-first .visual-column,\n  .section-visuals-layout.is-first .text-column {\n    order: initial !important;\n    flex: initial !important;\n  }\n\n  .section-visuals-layout.is-first .visual-column img {\n    height: auto !important;\n  }\n\n  .characters-layout {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .characters-layout__left,\n  .characters-layout__right {\n    justify-content: center;\n  }\n\n  .gallery-grid-moustik {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .gallery-grid-moustik .gallery-item {\n    width: 100%;\n  }\n\n  .project-detail--borrowed-time .gallery-grid {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  }\n\n  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(1) {\n    grid-column: span 1;\n    grid-row: span 1;\n  }\n\n  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(5) {\n    grid-column: span 1;\n  }\n\n  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(9),\n  .project-detail--borrowed-time .gallery-grid .gallery-item:nth-child(10) {\n    grid-row: span 1;\n  }\n\n  .project-detail.borrowed-time .gallery-masonry {\n    column-count: 3;\n  }\n}\n\n/* Tablet (768px - 1023px) */\n@media (max-width: 968px) {\n  .borrowed-time-layout {\n    grid-template-columns: 1fr !important;\n    gap: 2rem !important;\n  }\n\n  .borrowed-time-layout .image-column {\n    position: static !important;\n    order: -1;\n  }\n}\n\n/* Mobile large et Tablet (768px - 967px) */\n@media (max-width: 768px) {\n  .hero-image-wrapper {\n    min-height: 60vh;\n  }\n\n  .hero-image-wrapper:hover [class~=\"hero-logo\"],\n  .hero-image-wrapper:hover .hero-logo {\n    transform: translateY(-2px) scale(1.02);\n  }\n\n  .image-container-hover:hover {\n    transform: translateY(-4px) scale(1.01);\n  }\n\n  .gallery-item:hover {\n    transform: translateY(-3px);\n  }\n\n  .btn-elegant:hover {\n    transform: translateY(-1px);\n  }\n\n  .section-visuals-layout {\n    gap: 1.5rem;\n  }\n\n  .section-visuals-layout .visual-column img {\n    max-height: 21.875rem;\n  }\n\n  /* Réduire légèrement les rayons sur mobile pour économiser l'espace visible */\n  .responsive-media { border-radius: 10px; }\n\n  .gallery-grid {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto auto;\n  }\n\n  .gallery-item:nth-child(1) { grid-column: 1; grid-row: 1; }\n  .gallery-item:nth-child(2) { grid-column: 2; grid-row: 1; }\n  .gallery-item:nth-child(3) { grid-column: 1; grid-row: 2; }\n  .gallery-item:nth-child(4) { grid-column: 2; grid-row: 2; }\n  .gallery-item:nth-child(5) { grid-column: 1; grid-row: 3; }\n  .gallery-item:nth-child(6) { grid-column: 2; grid-row: 3; }\n\n  .gallery-item:nth-child(6) img {\n    height: auto;\n  }\n\n  .moustik-layout {\n    grid-template-columns: 1fr !important;\n    gap: 2rem !important;\n  }\n\n  .moustik-layout > div {\n    position: static !important;\n  }\n\n  .project-detail.borrowed-time .section-two-col {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Mobile (640px - 767px) */\n@media (max-width: 640px) {\n  .gallery-grid-moustik {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  /* Toutes galeries en 1 colonne pour lisibilité sur petits écrans */\n  .gallery-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .project-detail--borrowed-time .gallery-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .project-detail.borrowed-time .gallery-masonry {\n    column-count: 2;\n  }\n}\n\n/* Mobile petit et très petit */\n@media (max-width: 480px) {\n  .project-detail.borrowed-time .gallery-masonry {\n    column-count: 1;\n  }\n}\n\n/* Tablet (1024px - 1199px) spécifique Moustik */\n@media (max-width: 1200px) {\n  .moustik-layout {\n    grid-template-columns: 1fr 3fr 1fr !important;\n    gap: 1.5rem !important;\n  }\n}\n\n/* Préférence réduite pour les animations (accessibilité) */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* ========================================================================\n   PROJET : LES FEMMES DU LAVOIR (LES LAVANDIÈRES)\n   ======================================================================== */\n\n.project-detail--les-femmes-du-lavoir,\n.project-detail--les-lavandieres {\n  background-color: #F8F5F2;\n  color: #1A1A1A;\n  min-height: 100vh;\n  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;\n  overflow-x: hidden;\n}\n\n/* Nav header */\n.lavoir-nav-header {\n  padding: 1.5rem 2.5rem;\n  position: sticky;\n  top: 0;\n  background-color: rgba(248, 245, 242, 0.92);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n}\n\n.lavoir-back-button {\n  background: transparent;\n  border: 1.5px solid #1A1A1A;\n  color: #1A1A1A;\n  padding: 0.5rem 1.4rem;\n  border-radius: 30px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.lavoir-back-button:hover {\n  background: #1A1A1A;\n  color: #F8F5F2;\n  transform: translateX(-3px);\n}\n\n/* Main Container */\n.lavoir-main {\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 2rem 5% 6rem;\n}\n\n/* Hero Section */\n.lavoir-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 5rem;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.lavoir-poster-container {\n  max-width: 900px;\n  width: 100%;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.1);\n  transition: transform 0.4s ease, box-shadow 0.4s ease;\n}\n\n.lavoir-poster-container:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 55px rgba(0, 0, 0, 0.14);\n}\n\n.lavoir-poster-img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.lavoir-tagline {\n  margin-top: 2.2rem;\n  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;\n  font-size: clamp(1.05rem, 2.2vw, 1.25rem);\n  color: #2A2A2A;\n  text-align: center;\n  max-width: 820px;\n  line-height: 1.7;\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: 0.02em;\n}\n\n/* Header section */\n.lavoir-header-section {\n  text-align: center;\n  margin: 5rem 0 7rem;\n}\n\n.lavoir-main-title {\n  font-family: 'Brittany', 'Great Vibes', 'Caveat', cursive;\n  font-size: clamp(3.2rem, 8vw, 6rem);\n  font-weight: normal;\n  color: #1A1A1A;\n  margin: 0 0 1rem 0;\n  line-height: 1.15;\n  letter-spacing: 0.02em;\n}\n\n.lavoir-main-subtitle {\n  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;\n  font-size: clamp(0.95rem, 2vw, 1.2rem);\n  color: #4A4A4A;\n  letter-spacing: 0.1em;\n  margin: 0;\n  font-weight: 500;\n}\n\n/* Common Section */\n.lavoir-section {\n  margin-bottom: 7rem;\n}\n\n.lavoir-section-heading {\n  font-family: 'Brittany', 'Great Vibes', 'Caveat', cursive;\n  font-size: clamp(2.8rem, 6.5vw, 4.8rem);\n  font-weight: normal;\n  color: #1A1A1A;\n  text-align: center;\n  margin: 0 0 3.5rem 0;\n  line-height: 1.2;\n}\n\n/* Section L'histoire */\n.lavoir-histoire-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n.lavoir-histoire-text p {\n  font-family: 'Playfair Display', 'Georgia', 'Garamond', serif;\n  font-size: 1.05rem;\n  line-height: 1.95;\n  color: #2D2D2D;\n  margin: 0 0 1.8rem 0;\n  text-align: justify;\n}\n\n.lavoir-histoire-text p:last-child {\n  margin-bottom: 0;\n}\n\n.lavoir-histoire-media {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.08);\n  transition: transform 0.4s ease, box-shadow 0.4s ease;\n}\n\n.lavoir-histoire-media:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.12);\n}\n\n.lavoir-histoire-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n/* Section Inspirations */\n.lavoir-inspirations-container {\n  width: 100%;\n  max-width: 1250px;\n  margin: 0 auto;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.08);\n  transition: transform 0.4s ease, box-shadow 0.4s ease;\n}\n\n.lavoir-inspirations-container:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.12);\n}\n\n.lavoir-inspirations-img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Section Silhouettes */\n.lavoir-silhouettes-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2.5rem 2rem;\n  align-items: end;\n  justify-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.lavoir-silhouette-item {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.lavoir-silhouette-item:hover {\n  transform: translateY(-10px) scale(1.02);\n}\n\n.lavoir-silhouette-img {\n  max-width: 100%;\n  max-height: 480px;\n  width: auto;\n  height: auto;\n  display: block;\n  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.06));\n}\n\n/* Section Galerie */\n.lavoir-gallery-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  max-width: 1250px;\n  margin: 0 auto;\n}\n\n.lavoir-gallery-row {\n  display: flex;\n  gap: 1.8rem;\n  align-items: stretch;\n  width: 100%;\n}\n\n.lavoir-gallery-item {\n  overflow: hidden;\n  border-radius: 6px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n  transition: transform 0.4s ease, box-shadow 0.4s ease;\n  background-color: #EFEBE6;\n}\n\n.lavoir-gallery-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.14);\n}\n\n.lavoir-gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.5s ease;\n}\n\n.lavoir-gallery-item:hover img {\n  transform: scale(1.025);\n}\n\n/* Row 1 proportions: portrait (750x1000) / landscape (1200x900) / portrait (750x1000) */\n.lavoir-gallery-row--3 .lavoir-gallery-item--portrait {\n  flex: 0.75;\n}\n.lavoir-gallery-row--3 .lavoir-gallery-item--landscape {\n  flex: 1.333;\n}\n\n/* Row 2 proportions: 1229x920 / 1433x808 */\n.lavoir-gallery-row--2 .lavoir-gallery-item--medium {\n  flex: 1.336;\n}\n.lavoir-gallery-row--2 .lavoir-gallery-item--wide {\n  flex: 1.773;\n}\n\n/* Row 3 proportions: 750x1000 / 1229x921 */\n.lavoir-gallery-row--2-alt .lavoir-gallery-item--portrait {\n  flex: 0.75;\n}\n.lavoir-gallery-row--2-alt .lavoir-gallery-item--wide {\n  flex: 1.334;\n}\n\n/* Footer / CTA */\n.lavoir-footer {\n  text-align: center;\n  padding: 6rem 2rem 8rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.lavoir-footer-title {\n  font-family: 'Brittany', 'Great Vibes', 'Caveat', cursive;\n  font-size: clamp(3rem, 7vw, 5.2rem);\n  font-weight: normal;\n  color: #1A1A1A;\n  margin: 0 0 2.5rem 0;\n  line-height: 1.15;\n  cursor: pointer;\n  transition: transform 0.3s ease, color 0.3s ease;\n}\n\n.lavoir-footer-title:hover {\n  color: #61554E;\n  transform: scale(1.02);\n}\n\n.lavoir-footer-btn {\n  background: #1A1A1A;\n  color: #F8F5F2;\n  border: 1.5px solid #1A1A1A;\n  padding: 1.1rem 3rem;\n  border-radius: 40px;\n  font-size: 1.05rem;\n  font-weight: 500;\n  letter-spacing: 0.08em;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.lavoir-footer-btn:hover {\n  background: transparent;\n  color: #1A1A1A;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.16);\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .lavoir-histoire-grid {\n    grid-template-columns: 1fr;\n    gap: 2.5rem;\n  }\n\n  .lavoir-silhouettes-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2rem 1.5rem;\n  }\n\n  .lavoir-gallery-row {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  .lavoir-gallery-item {\n    min-height: 300px;\n  }\n}\n\n/* ========================================================================\n   FIN DU FICHIER\n   ======================================================================== */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
